import { Button } from '@insify/design-system/components';
import { useBreakpoint } from '@insify/react-hooks';
import clsx from 'clsx';
import { Trans, useTranslation } from 'react-i18next';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import { Heading2, Paragraph } from '../../../components/Typography/Typography';
import { useCountrySpecificContent } from '../../../utils/localize';
import { AuthLayout } from '../../layouts/AuthLayout';

import { bodyText, btnGroup, content, fullWidthBtn, heading, inverseBtn } from './EmailSentPage.module.css';

const EmailSentPage = () => {
  const { landing_page_contact } = useCountrySpecificContent();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { t } = useTranslation('common');
  const isMobile = !useBreakpoint('(min-width: 960px)');

  const getSupport = () => {
    window.open(landing_page_contact, '_blank');
  };

  if (!state || state.email === undefined) {
    return <Navigate to='/login' />;
  }

  return (
    <AuthLayout>
      <div className={content}>
        <Heading2 testId='login-link-sent-header' className={heading} density='condensed'>
          {t('login_link_sent_title')}
        </Heading2>
        <Paragraph className={bodyText}>
          <Trans
            data-hj-suppress
            i18nKey='common:login_link_sent_body'
            values={{ email: state.email }}
            components={[<strong key={'link_sent'} />]}
          />
        </Paragraph>
      </div>
      <div className={btnGroup}>
        <Button
          trackingId='resend'
          className={fullWidthBtn}
          type='button'
          kind={isMobile ? 'neutral' : 'primary'}
          onClick={() => navigate('/login')}
        >
          {t('login_link_sent_request_new_link')}
        </Button>

        <Button
          className={clsx(fullWidthBtn, isMobile ? inverseBtn : '')}
          type='button'
          kind={isMobile ? 'tertiary' : 'secondary'}
          trackingId='support'
          onClick={getSupport}
        >
          {t('login_link_sent_support')}
        </Button>
      </div>
    </AuthLayout>
  );
};

export { EmailSentPage };
